<template>
  <b-card class="w-100" body-class="pb-1">
    <div class="d-flex align-items-center text-white pb-2">
      <feather-icon icon="ClockIcon" class="mr-50" />
      <small>Leatest competition</small>
    </div>
    <div class=" d-flex flex-column justify-content-between">
      <div
        class="d-flex align-items-baseline justify-content-center px-0 my-1 py-50"
      >
        <div v-if="loading">
          <div class="d-flex align-items-center justify-content-center">
            <b-skeleton
              class="rounded-circle mr-0"
              width="140px"
              height="140px"
            ></b-skeleton>
          </div>
          <div class="d-flex align-items-center justify-content-center mt-1">
            <b-skeleton width="40px" height="15px" class="mx-50"></b-skeleton>
            <b-skeleton width="40px" height="15px" class="mx-50"></b-skeleton>
          </div>
        </div>
        <div
          v-else-if="
            dashboard &&
            dashboard.latest_competition &&
            (dashboard.latest_competition.active_participants_count ||
              dashboard.kicked_participants_count)
          "
        >
          <doughnut-chart
            :chartData="chartData"
            :colors="['#028c6b', '#ed1c24']"
            :labels="['Active', 'Eliminated']"
            height="120px"
            width="120px"
          />
        </div>

        <template v-else>
          <div class="d-flex justify-content-center h-100 new-alert">
            <div
              class="mt-2"
              style="
                border-radius: 100px;
                height: 115px;
                width: 115px;
                border: 23px solid rgb(45 45 53 / 44%);
              "
            ></div>
          </div>
        </template>
      </div>

      <div class="">
        <span>Top 3 Participants:</span>
        <template v-if="loading">
          <div
            class="d-flex align-items-center justify-content-center mt-1"
            v-for="i in 3"
            :key="i"
          >
            <b-skeleton width="40px" height="40px" class="mx-50"></b-skeleton>
            <b-skeleton width="80px" height="20px" class="mx-50"></b-skeleton>
            <b-skeleton width="40px" height="20px" class="mx-50"></b-skeleton>
          </div>
        </template>
        <template v-else-if="participants.length">
          <div
            class="d-flex bg-secondary rounded p-1 align-items-center justify-content-between my-50"
            v-for="(participant, index) in participants"
            :key="index"
          >
            <div class="d-flex align-items-center">
              <b-avatar
                class="rounded-avatar"
                style="border: 2px solid #4d556d"
                :alt="participant.first_name + ' ' + participant.last_name"
                :src="participant.avatar || errorImage"
                @error="setAltImg"
              />
              <span class="ml-50">{{
                participant.first_name + " " + participant.last_name
              }}</span>
            </div>
            <span class="text-info">{{ participant.pivot.rank }}</span>
          </div>
        </template>
        <template v-else>
          <div
            class="d-flex align-items-center justify-content-center h-100 new-alert"
          >
            <b-alert
              show
              variant="secondary"
              class="d-flex align-items-center justify-content-center p-3 w-100"
            >
              no information
            </b-alert>
          </div>
        </template>
      </div>
    </div>
  </b-card>
</template>

<script>
import DoughnutChart from "@/views/components/doughnut-chart/DoughnutChart.vue";
import {
  BCard,
  BButton,
  BMedia,
  BMediaAside,
  BMediaBody,
  BAvatar,
  BSkeleton,
  BAlert,
} from "bootstrap-vue";
export default {
  components: {
    BCard,
    BButton,
    BMedia,
    BMediaAside,
    BMediaBody,
    BAvatar,
    BSkeleton,
    BAlert,
    DoughnutChart,
  },
  data() {
    return {
      participants: [],
    };
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    dashboard: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    chartData() {
      return [
        this.dashboard.latest_competition.active_participants_count,
        this.dashboard.kicked_participants_count,
      ];
    },
  },
  watch: {
    dashboard(val) {
      if (val.latest_competition && val.latest_competition.top_participants) {
        this.participants = val.latest_competition.top_participants;
        this.participants.sort(
          (a, b) => Number(a.pivot.rank) - Number(b.pivot.rank)
        );
      }
    },
  },
};
</script>
